import {NgModule} from '@angular/core';
import {
    AreInProgressPipe,
    AreReady,
    AreStopped,
    HasGoodQuality,
    HasNotGoodQuality,
    HaveNotBeenRed,
    IsNotReady,
    IsReady,
    ProgressBuffer,
    ProgressValue,
    WaitForValidation,
} from './shared.pipe';

@NgModule({
    declarations: [
        AreStopped,
        AreInProgressPipe,
        AreReady,
        IsReady,
        IsNotReady,
        WaitForValidation,
        HasGoodQuality,
        HasNotGoodQuality,
        ProgressValue,
        ProgressBuffer,
        HaveNotBeenRed,
    ],
    exports: [
        AreStopped,
        AreInProgressPipe,
        AreReady,
        IsReady,
        IsNotReady,
        WaitForValidation,
        HasGoodQuality,
        HasNotGoodQuality,
        ProgressValue,
        ProgressBuffer,
        HaveNotBeenRed,
    ],
})
export class PipesModule {}
